// extracted by mini-css-extract-plugin
export default {"container":"CTz6zT9xrlhdAD8Y5MKA","checkmark":"_TBjdGszyknu3GXrv5O1","label":"m9imMwsZJh58okmFOtJF"};